// Types
import * as Types from '../types'
import {requestActionProps, requestGenerate} from '../../common'
import api from '../../../services/api'
import { callbackProps, ID } from "../../../constants";
import {store} from "../../ROOT";
import {SET_TASK_COMPLETED} from "../../onboarding/actions";

const actionGetTotalSummaryReport = (
  payload: any,
  callback?: (a: callbackProps) => void
): requestActionProps => ({
  type: requestGenerate(Types.REQUEST),
  api: api.getTotalSummaryReport,
  payload: {data: new URLSearchParams(payload)},
  callback: (response: any) => {
    const data = response.payload?.data
    const empty = data?.status === false && data?.errorName === 'NotFound'
    if (response.type !== 'SUCCESS' && !empty) {
      callback && callback({type: 'FAILURE', payload: response})
      return
    }
    if (empty) {
      store.dispatch({ type: SET_TASK_COMPLETED, payload: 'assignmentsCreated', value: false });
    } else {
      store.dispatch({ type: SET_TASK_COMPLETED, payload: 'assignmentsCreated', value: true });
    }
    callback && callback({ type: 'SUCCESS', payload: response });
  }
})
const actionGetUserSummaryReport = (
  payload: ID,
  callback?: (a: callbackProps) => void
): requestActionProps => ({
  payload: { data: payload },
  type: requestGenerate(Types.REQUEST),
  api: api.getUserSummaryReport,
  callback,
})
const actionHomeworkReport = (
  payload: any,
  callback?: (a: callbackProps) => void
): requestActionProps => ({
  type: requestGenerate(Types.REQUEST),
  api: api.getHomeworkReport,
  payload: {data: new URLSearchParams(payload)},
  callback,
})

const actionGetMostReaders = (
  payload: any,
  callback?: (a: callbackProps) => void
): requestActionProps => ({
  type: requestGenerate(Types.REQUEST),
  api: api.getMostReaders,
  payload: {data: new URLSearchParams(payload)},
  callback,
})
export {
  actionGetTotalSummaryReport,
  actionHomeworkReport,
  actionGetMostReaders,
  actionGetUserSummaryReport
}
